import { LocaleEnum } from '../const';

export function getFallbackLng() {
  return LocaleEnum.English;
}
